(function () {
    'use strict';

    angular.module('swif.interventions')
        .config(router)
        .filter('swifplanningfilter', swifplanningfilter)
        .controller('InterventionPlanningController', InterventionPlanningController)
        .controller('PlanningEventModal', PlanningEventModal)
        .controller('TaskAssignModalController', TaskAssignModalController)
        .component('planningPrintTable', {
            templateUrl: 'partials/openstc/planning_print_table.html',
            bindings: {
                getResources: '&',
                days: '=',
                planning: '=',
                tasks: '=',
                forType: '=',
                interById: '='
            }
        });

    function router ($routeProvider) {
        'ngInject';
        $routeProvider.when('/interventions/planning', {
            templateUrl: 'partials/openstc/planning.html',
            controller: 'InterventionPlanningController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.planning.resolveData();
                }]
            }
        });
        $routeProvider.when('/interventions/planning_print', {
            templateUrl: 'partials/openstc/planning_print.html',
            controller: 'InterventionPlanningController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    return service.planning.resolveData();
                }]
            }
        });
    }

    function swifplanningfilter () {
        return function(items, options) {
            var out = [];
            var ok;
            _.forEach(items, function (item){
                ok = true;
                if (options.date) {
                    if (!_.contains(item.date_start, options.date) && !_.contains(item.date_end, options.date)) {
                        ok = false;
                    }
                }
                if (options.type === "user") {
                    if (item.user_id) {
                        if (item.user_id[0] !== options.agent.id) {
                            ok = false;
                        }
                    } else if (item.team_id && options.agent.team_ids) {
                        if (!_.contains(options.agent.team_ids, item.team_id[0])) {
                            ok = false;
                        }
                    } else {
                        ok = false;
                    }
                }
                if (options.type === "team") {
                    if (item.team_id) {
                        if (item.team_id[0] !== options.agent) {
                            ok = false;
                        }
                    }
                }
                if (ok) {
                    out.push(item);
                }
            });
            return out;
        };
    }

    function InterventionPlanningController ($q, $rootScope, $scope, $location, $uibModal, $timeout, uiCalendarConfig, swif, openstc, data, openstcResourcesService) {
        'ngInject';

        console.log('init InterventionPlanningController');
        swif.settings.page.title = 'Planning';

        $scope.debug = $location.search().debug || false;
        $scope.data = data;
        $scope.loading = {events: {}};
        $scope.settings = swif.settings;
        $scope.modules = swif.module.modules;
        $scope.project_type = data.project_type || 'intervention';
        $scope.project_type_label = 'Interventions';
        $scope.project_types = [
            ['intervention', swif.i18n.getString('Interventions')],
            ['patrimoine_contract', swif.i18n.getString('Controls-Contracts')]
        ];
        //display interventions and tasks
        $scope.displayInterventions = false;
        $scope.displayResources = true;
        $scope.displayTasksSearch = false;
        $scope.displayPunchs = true;

        $scope.createOrUpdatePlannedTasks = createOrUpdatePlannedTasks;
        $scope.resources = openstcResourcesService;
        $scope.formatAgentToList = formatAgentToList;
        /**
         * calendar related methods
         */
        $scope.planning = openstc.planning;
        $scope.plannings_type = [];
        $scope.plannedTaskFields = ['actions', 'category_id', 'date_end', 'date_start', 'id', 'swif_id', 'name', 'planned_hours', 'state', 'team_id', 'user_id', 'partner_id', 'external', 'ask_id', 'recurrence_id', 'project_id', 'service_id', 'description'];

        $scope.fullcalendar = openstc.planning.getFullcalendar();
        $scope.fullcalendar.timezone = swif.user.getTimeZone();
        //$scope.fullcalendar.timezone = 'UTC';
        $scope.tasksStates = swif.settings.getContentType('task').states;
        $scope.eventSources = [];
        $scope.currentPlanning = false;
        $scope.fullcalendar.eventMouseover = eventMouseover;
        $scope.fullcalendar.eventMouseout = eventMouseout;
        $scope.refreshCollections = refreshCollections;
        $scope.printView = false;
        $scope.fullcalendar.viewRender = fullcalendarRender;
        //print related stuff
        $scope.loadPlannedTask = loadPlannedTask;
        $scope.planningPrint = planningPrint;
        $scope.fullcalendar.droppable = true;
        $scope.fullcalendar.drop = fullcalendarDrop;
        $scope.fullcalendar.eventClick = fullcalendarEventClick;
        $scope.expanded = false;
        $scope.fullcalendar.toggleExpand = fullcalendarToggleExpand;
        $scope.fullcalendar.eventDrop = fullcalendarEventDrop;
        $scope.fullcalendar.eventResize = fullcalendarEventResize;
        $scope.fullcalendar.eventRender = fullcalendarEventRender;
        $scope.fullcalendar.select = fullcalendarSelect;
        $scope.fullcalendar.header.left = "month agendaWeek agendaDay";
        $scope.fullcalendar.header.right = "goToDateButton,today prev,next";
        $scope.fullcalendar.columnFormat = {
			month: "dddd",
			week : "dddd D/MM",
			day  : "dddd"
		};
        $scope.defaultBusinessHours = $scope.fullcalendar.businessHours;
        swif.fullcalendar.parseLocation($scope.fullcalendar);
        /**
         * Manage interventions
         */
        $scope.preModalIntervention = openstc.planning.preModalIntervention;
        $scope.preValidateIntervention = openstc.intervention.preValidate;
        $scope.callbackIntervention = openstc.planning.callbackIntervention;
        $scope.interventions = data.interventions;
        $scope.displayInterventionPanel = displayInterventionPanel;
        $scope.closeInterventionPanel = closeInterventionPanel;
        $scope.getInterventions = getInterventions;
        $scope.getTasks = getTasks;
        /**
         * Manage tasks
         */
        $scope.getTaskTooltip = getTaskTooltip;
        $scope.setPlanningDateAndResourceFromTask = setPlanningDateAndResourceFromTask;
        $scope.callbackTask = openstc.planning.callbackTask;
        $scope.preValidateTask = openstc.planning.preValidateTask;
        $scope.preModalTask = openstc.planning.preModalTask;
        $scope.tasks = data.tasks;
        /**
         * Manage tasks to close
         */
        $scope.showCloseWeekTasksButton = false;
        $scope.displayWeekTasksToClose = false;
        $scope.displaySelectedTasksToClose = true;
        $scope.removeTaskToCloseById = removeTaskToCloseById;
        $scope.displayWeekTasksToCloseFrame = displayWeekTasksToCloseFrame;
        $scope.displayPlanning = displayPlanning;
        $scope.closeWeekTasks = closeWeekTasks;
        $scope.tasksToClose = [];
        $scope.pagination = {page: 1};
        $scope.maxItemsPerPage = 10;
        /**
         * Officers (watch-only)
         */
        $scope.selectedOfficersOrTeam = openstcResourcesService.current;
        /**
         * Global UI
         */
        $scope.displayTaskPanel = displayTaskPanel;
        $scope.closeTaskInfo = closeTaskInfo;
        $scope.onDragTaskComplete = onDragTaskComplete;
        $scope.hasOpenresaModule = swif.module.modules.openresa;
        $scope.onChangePlanningType = onChangePlanningType;
        $scope.fillWeekWithTask = fillWeekWithTask;

        $scope.$watch('interventions.currentItem', watchCurrentIntervention);
        $scope.$watch('interventions.items', watchInterventionsItems);
        $scope.$watch('project_type', watchProjectType);

        $scope.$watch('plannedTasks.items', watchPlannedTasksItems, true);
        $scope.$watch('selectedOfficersOrTeam', _ => {
            loadPunchs();
            loadBookings();
        }, true);

        var resourcesWatcher = $scope.$watchGroup(
            ['resources.officers', 'resources.teams', 'resources.serviceSuppliers'],
            function(n) {
                if (n[0] !== undefined || n[1] !== undefined || n[2] !== undefined) {
                    loadBookings();
                    resourcesWatcher();
                }
            }
        );

        function watchProjectType(newV) {
            $location.search('project_type', newV);
            if (newV === 'intervention') {
                $scope.project_type_label = 'Interventions';
            } else if (newV === 'patrimoine_contract') {
                $scope.project_type_label = 'Controls-Contracts';
            }
            if ($scope.interventions) {
                if ($scope.interventions.contentType !== newV) {
                    $scope.interventions.contentType = newV;
                    $scope.interventions.currentFilter = {};
                }
            }
        }

        function refreshPlanningTasks() {
            $scope.getTasks();
        }

        function createOrUpdatePlannedTasks () {
            openstc.planning.updateFullCalendar($scope.fullcalendar);
            if (
                openstc.planning.currentStart &&
                openstc.planning.currentEnd
            ) {
                var eventFilters = updatePlannedTasksFilter();
                if (eventFilters.filters === undefined) {
                    eventFilters.limit = 1;
                } else if (eventFilters.limit === 1) {
                    delete eventFilters.limit;
                }
                swif.collections.createOrUpdate(
                    'planned-tasks',
                    'task',
                    eventFilters,
                    {
                        limitPerPage: 0
                    }
                ).then(
                    function (collection) {
                        $scope.plannedTasks = collection;
                    }
                );
            }
        }

        function getCurrentResource () {
            return openstcResourcesService.getCurrent();
        }

        function formatAgentToList(agent) {
            if (agent === undefined) {
                return [];
            } else if (Array.isArray(agent)) {
                return agent;
            } else {
                return [agent];
            }
        }

        function showEventPanel(eventData, jsEvent) {
            $scope.overEvent = eventData;
            var my = jsEvent.clientY;
            var mx = jsEvent.clientX;
            var viewPortWidth = window.innerWidth;
            var viewPortHeight = window.innerHeight;
            //test to much high
            var options = {position: 'absolute'};
            if (my < viewPortHeight - 300) {
                options.top = jsEvent.pageY;
            } else if (my > viewPortHeight - 300){
                options.top = jsEvent.pageY - 300;
            }
            if (mx < viewPortWidth - 300) {
                options.left = jsEvent.pageX;
            } else if (mx > viewPortWidth - 300){
                options.left = jsEvent.pageX - 300;
            }
            $('#panelTaskOver').removeClass('ng-hide').css(options);
        }

        function _setCursorToCopy() {
            var canvas = document.createElement("canvas");
            canvas.width = 24;
            canvas.height = 24;
            //document.body.appendChild(canvas);
            var ctx = canvas.getContext("2d");
            ctx.fillStyle = "#000000";
            ctx.font = "20px FontAwesome";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText("\uf0c5", 12, 12);
            var dataURL = canvas.toDataURL('image/png')
            var cal = document.getElementsByClassName('calendar')[0];
            cal.style.cursor = 'url(' + dataURL + '), auto';
        }

        function _setCursorToDefault() {
            var cal = document.getElementsByClassName('calendar')[0];
            cal.style.cursor = 'default';
        }

        var _eventkeydownFunction = function(e) {
            if (e.altKey && $scope.hoverEvent) {
                _setCursorToCopy();
            }
        };
        document.addEventListener('keydown', _eventkeydownFunction);

        var _eventkeyupFunction = function() { _setCursorToDefault(); };
        document.addEventListener('keyup', _eventkeyupFunction);

        function eventMouseover(event, jsEvent) {
            if (!event.data) {
                return;
            }
            $scope.hoverEvent = true;
            if (jsEvent.altKey) {
                _setCursorToCopy();
            }
            $scope.displayPanel = setTimeout(function () {
                var params = {fields: []};
                if (event.data._type === 'task' && ! event.data.external) {
                    params.fields = [
                        'id',
                        'swif_id',
                        'consumable_swif_id',
                        'consumable_asks',
                        'name',
                        'state',
                        'site1',
                        'site_details',
                        'category_id',
                        'service_id',
                        'user_id',
                        'team_id',
                        'partner_id',
                        'project_id',
                        'date_start',
                        'date_end',
                        'recurrence_id',
                        'planned_hours',
                        'effective_hours',
                        'equipment_id',
                        'description',
                        'ask_id',
                        'external'
                    ];
                    swif.data.get(event.data._type, event.data.id, params).then(function(task) {
                        showEventPanel(task, jsEvent);
                    });
                } else if (event.data._type === 'punch' ||
                           ((event.data._type === 'task') && event.data.external)) {
                    showEventPanel(event.data, jsEvent);
                } else if (event.data._type === 'reservation') {
                    params.fields = [
                        'name',
                        'note',
                        'checkin',
                        'checkout',
                        'color',
                        'state',
                        'resource_ids',
                        'resource_names',
                        'recurrence_id',
                        'request_id',
                        'partner_invoice_id',
                        'reservation_line',
                        'whole_day',
                        'actions',
                        'expected_people',
                        'resource_detail',
                        'has_recurrence'
                        // 'partner_id' // We don't want to show requester here
                    ]
                    swif.data.get(event.data._type, event.data.id, params).then(function(booking) {
                        showEventPanel(booking, jsEvent);
                    });
                }

            }, 1000);
        }

        function eventMouseout ( event ) {
            if (!event.data) {
                return;
            }
            $scope.hoverEvent = false;
            _setCursorToDefault();
            if ($scope.displayPanel) {
                clearTimeout($scope.displayPanel);
            }
            setTimeout(function () {
                $('#panelTaskOver').addClass('ng-hide');
            }, 500);
        }

        var getEventFromTask = openstc.planning.getEventFromTask;

        function getTaskFromEvent (event) {
            return openstc.planning.getTaskFromEvent(
                $scope.plannedTasks.items, event
            );
        }

        function updatePlannedTasksFilter () {
            var filter;

            //var plannedTasks = collections.getCollection('planned-tasks');
            if (!$scope.plannedTasks) {
                filter = {};
            } else {
                filter = $scope.plannedTasks.currentFilter;
            }
            filter.fields = $scope.plannedTaskFields;
            var options = getCurrentResource();
            if (openstc.planning.currentStart) {
                options.start = openstc.planning.currentStart;
            }
            if (openstc.planning.currentEnd) {
                options.end = openstc.planning.currentEnd;
            }
            openstc.planning.updateFilter(filter, options);
            return filter;
        }

        /**
         * Create the collection if not exist, or just update the filter
         * @return {[type]} [description]
         */
        function refreshCollections () {
            if ($scope.plannedTasks) {
                $scope.plannedTasks.getItems();
            }
            if ($scope.tasks) {
                $scope.tasks.getItems();
            }
            if ($scope.interventions) {
                $scope.interventions.getItems();
            }
        }

        function fullcalendarRender(view) {
            $scope.printView = false;
            openstc.planning.currentStart = view.start;
            openstc.planning.currentEnd = view.end;
            $scope.fullcalendarView = view.name;
            swif.fullcalendar.updateLocation(view);

            if (view.name === 'month') {
                $scope.displayPunchs = false;
            } else {
                $scope.displayPunchs = true;
            }

            loadPunchs();
            loadSpecialDays();
            loadBookings();
            createOrUpdatePlannedTasks();

            if (swif.module.modules.opengst_carto && view.name === 'agendaDay') {
                $scope.displayMap = true;
            } else {
                $scope.displayMap = false;
            }
        }

        function loadPlannedTask() {
            //used to print the tasks
            $scope.printView = true;
            if (!_.contains($scope.plannedTaskFields, 'site1')) {
                $scope.plannedTaskFields.push('site1');
            }
            if (!_.contains($scope.plannedTaskFields, 'project_id')) {
                $scope.plannedTaskFields.push('project_id');
            }
            if (!openstc.planning.currentStart) {
                openstc.planning.currentStart = moment().startOf('isoWeek');
            }
            if (!openstc.planning.currentEnd) {
                openstc.planning.currentEnd = moment().endOf('isoWeek');
            }
            $scope.currentDays = [];
            var hiddenDays = $scope.fullcalendar.hiddenDays;
            for (var i = 0; i < 7; i++) {
                if (hiddenDays[i+1]) {
                    continue;
                } else if (i === 6 && hiddenDays[0]) {
                    continue;
                }
                $scope.currentDays.push(
                    moment(openstc.planning.currentStart).add(i, 'days').format('YYYY-MM-DD')
                );
            }
            createOrUpdatePlannedTasks();
        }

        function planningPrint() {
            $scope.expanded = true;
            setTimeout(function () {
                window.print();
                $scope.expanded = false;
                $scope.$apply();
            }, 1000);
        }

        function loadPrintDataFromTask(options) {
            var filter;
            if (options.inter_ids) {
                filter = {};
                filter.fields = ['description', 'ask_id'];
                swif.data.addFilter(filter, 'id', 'in', options.inter_ids);
                swif.data.searchRead('intervention', filter).then(function (interventions) {
                    //TODO: attach to plannedTasks
                    $scope.interById = {};
                    _.forEach(interventions.records, function (inter) {
                        $scope.interById[inter.id] = inter;
                    });
                });
            }
        }

        function loadSpecialDays() {
            $scope.eventSources[1] = [];
            swif.fullcalendar.addSpecialDays($scope.eventSources[1]);
        }

        function loadPunchs() {
            if (! $scope.displayPunchs) {
                $scope.eventSources[2] = [];
            } else {
                var filter = {fields: ["user_id", "type", "time"]};
                swif.data.addFilter(filter, 'time', '>=', openstc.planning.currentStart);
                swif.data.addFilter(filter, 'time', '<', openstc.planning.currentEnd);

                // If only some officers are checked, display punchs only for
                // those, else display all listed officers.
                var officers_list, user_ids;
                var team_user_ids = [];
                if (openstcResourcesService.current.officers.length > 0) {
                    officers_list = openstcResourcesService.current.officers;
                } else if (openstcResourcesService.current.team && openstcResourcesService.current.team.user_ids && openstcResourcesService.current.team.user_ids.length > 0) {
                    team_user_ids = openstcResourcesService.current.team.user_ids
                } else {
                    officers_list = openstcResourcesService.officers.items;
                }

                // team_user_ids is already an array of ids instead of officers_list.
                // We have to extract only user ids of officers_list
                if (team_user_ids.length > 0) {
                    user_ids = team_user_ids
                } else {
                    user_ids = _.pluck(officers_list, 'id');
                }

                swif.data.addFilter(
                    filter,
                    'user_id', 'in', user_ids
                );
                swif.data.searchRead('punch', filter).then(function (response) {
                    $scope.eventSources[2] = [];
                    _.forEach(response.records, function (punch) {
                        /* FIXME Weird to do str->str->moment instead of
                         * str->moment
                         *
                         * (weirdness copied from service.planning.getEventFromTask)
                         */
                        var punch_time = moment(swif.date.formatDatetime(punch.time,'YYYY-MM-DD HH:mm:ss'));
                        var punch_time_end = punch_time.clone();
                        punch_time_end.add(1, 'minutes');
                        var event = {
                            id: 'punch-'+punch.id ,
                            title: 'Punch-'+punch.type,
                            timezone: 'UTC',
                            start: punch_time,
                            end: punch_time_end,
                            allDay: false,
                            color: _.get(
                                openstc.planning.userColor, punch.user_id[0], '#888'),
                            editable: false,
                            data: punch
                        };
                        $scope.eventSources[2].push(event);
                    });
                });
            }
        }

        function loadBookings() {
            // openresa module should be activated
            if ($scope.hasOpenresaModule) {
                let productsFilter = { fields: ['id', 'resource_model', 'resource_id'] };
                let currentResourceModel = null;
                let current = openstcResourcesService.current;
                let resourceIds = [];

                if (current.officers.length > 0) {
                    currentResourceModel = 'res.users';
                    resourceIds = current.officers.map(o => o.id);
                } else if (current.team !== undefined) {
                    currentResourceModel = 'openstc.team';
                    resourceIds = [current.team.id];
                } else if (current.serviceSupplier !== undefined) {
                    currentResourceModel = 'res.partner';
                    resourceIds = [current.serviceSupplier.id];
                }

                if (currentResourceModel !== null) {
                    // Get ids of selected resources only
                    swif.data.addFilter(productsFilter, '&');
                    swif.data.addFilter(productsFilter, 'resource_model', '=', currentResourceModel);
                    swif.data.addFilter(productsFilter, 'resource_id', 'in', resourceIds);
                } else {
                    // No resource selected : we get all product ids of all users, teams, and suppliers already loaded
                    let officersIds = openstcResourcesService.officers ? openstcResourcesService.officers.items.map(o => o.id) : [];
                    let teamsIds = openstcResourcesService.teams ? openstcResourcesService.teams.items.map(t => t.id) : [];
                    let suppliersIds = openstcResourcesService.serviceSuppliers ? openstcResourcesService.serviceSuppliers.items.map(s => s.id) : []

                    swif.data.addFilter(productsFilter, '|');
                    swif.data.addFilter(productsFilter, '|');
                    swif.data.addFilter(productsFilter, '&');
                    swif.data.addFilter(productsFilter, 'resource_model', '=', 'res.users');
                    swif.data.addFilter(productsFilter, 'resource_id', 'in', officersIds);
                    swif.data.addFilter(productsFilter, '&');
                    swif.data.addFilter(productsFilter, 'resource_model', '=', 'openstc.team');
                    swif.data.addFilter(productsFilter, 'resource_id', 'in', teamsIds);
                    swif.data.addFilter(productsFilter, '&');
                    swif.data.addFilter(productsFilter, 'resource_model', '=', 'res.partner');
                    swif.data.addFilter(productsFilter, 'resource_id', 'in', suppliersIds);
                }

                swif.data.searchRead('product', productsFilter).then(products => {
                    let ids = [];

                    products.records.map(product => {
                        // Store product id
                        ids.push(product.id);

                        // Associate the product to its resource to get its color
                        let index, color, resId;
                        if (product.resource_model === 'res.users') {
                            index = openstcResourcesService.officers.items.findIndex(o => o.id === product.resource_id);
                            if (index !== -1) {
                                color = openstcResourcesService.officers.items[index].hex_color;
                                resId = openstcResourcesService.officers.items[index].id;
                            }
                        } else if (product.resource_model === 'openstc.team') {
                            index = openstcResourcesService.teams.items.findIndex(t => t.id === product.resource_id);
                            if (index !== -1) {
                                color = openstcResourcesService.teams.items[index].color;
                                resId = openstcResourcesService.teams.items[index].id;
                            }
                        } else if (product.resource_model === 'openstc.team') {
                            index = openstcResourcesService.serviceSuppliers.items.findIndex(s => s.id === product.resource_id);
                            if (index !== -1) {
                                color = openstcResourcesService.serviceSuppliers.items[index].color;
                                resId = openstcResourcesService.serviceSuppliers.items[index].id;
                            }
                        }
                        openstc.planning.productsColorMapping.push({productId: product.id, color, resId});
                    });

                    // Prepare filter to get bookings
                    let filter = {
                        fields: ['name', 'note', 'checkin', 'checkout', 'resource_names', 'state', 'whole_day']
                    };
                    swif.data.addFilter(filter, '|');
                    swif.data.addFilter(filter, '&');
                    swif.data.addFilter(filter, 'checkin', '>=', openstc.planning.currentStart);
                    swif.data.addFilter(filter, 'checkin', '<=', openstc.planning.currentEnd);
                    swif.data.addFilter(filter, '&');
                    swif.data.addFilter(filter, 'checkout', '>=', openstc.planning.currentStart);
                    swif.data.addFilter(filter, 'checkout', '<=', openstc.planning.currentEnd);
                    swif.data.addFilter(filter, 'reservation_line.product_id.id', 'in', ids);

                    swif.data.searchRead('reservation', filter).then(bookings => {
                        $scope.eventSources[3] = [];

                        bookings.records.map(booking => {
                            // For each booking, create as many event as resources it contains
                            openstc.planning.createBookingEvent(booking, $scope.eventSources[3]);
                        });
                    });
                });
            }
        }

        function loadPlanningType(planning) {
            var calendarDate = $("#fullcalendar").fullCalendar('getDate');
            var businessHours = [];
            for (const ts of planning.time_slots) {
                const startHour = `${Math.trunc(ts.range_start)}:${String(Math.trunc((ts.range_start % 1) * 60)).padStart(2, '0')}`;
                const endHour = `${Math.trunc(ts.range_end)}:${String(Math.trunc((ts.range_end % 1) * 60)).padStart(2, '0')}`;
                if (ts.day_start == ts.day_end) {
                    // Same day
                    var event = {
                        start: startHour,
                        end: endHour,
                        dow: [ts.day_start+1 == 7 ? 0 : ts.day_start+1],
                    };
                    businessHours.push(event);
                } else {
                    // On multiple day
                    const daysRange = _.range(ts.day_start+1, ts.day_end+2)
                    for (const [index, day] of daysRange.entries()) {
                        var event = {
                            start: index + 1 == daysRange.length ? '00:00' : startHour,
                            end: index == 0 ? '24:00' : endHour,
                            dow: [day == 7 ? 0 : day], // Reset to 0 if 7 (sunday) because fullcalendar use different weekday order
                        };
                        businessHours.push(event);
                    }
                }
            }
            if (businessHours.length === 0) {
                $scope.fullcalendar.businessHours = $scope.defaultBusinessHours
            } else {
                $scope.fullcalendar.businessHours = businessHours;
            }
            $timeout( function(){
                $("#fullcalendar").fullCalendar('gotoDate',calendarDate);
            }, 100 );
        }


        function removeTaskToCloseById(id){
            $scope.tasksToClose = _.remove($scope.tasksToClose, function(task) {
                return task.id != id;
            });
            //uncheck the box in the planned task
            let element = $('#'+id);
            if (element[0]) {
                element[0].checked = false;
            }
        }

        function displayPlanning(){
            $scope.displayWeekTasksToClose = false;
            // we change the full calendar buttons
            $scope.fullcalendar.header.left = "month agendaWeek agendaDay";
            forceTaskEventRerender();
        }

        function displayWeekTasksToCloseFrame() {
            $scope.displayWeekTasksToClose = true;
            // we change the full calendar buttons
            $scope.fullcalendar.header.left = "";
            forceTaskEventRerender();
        }

        function forceTaskEventRerender() {
            openstc.planning.fullcalendar.defaultDate = openstc.planning.currentStart;
            openstc.planning.fullcalendar.defaultView = $scope.fullcalendarView;

            //i didn't find how to rerender events in ui-calendar without change events
            if ($scope.plannedTasks.items.length){
                $scope.plannedTasks.items[0].newPropertie="GrosHack";
            }
        }

        function addToTasksToCloseById(id) {
            $scope.plannedTasks.getItem(id).then(function (task) {
                if ((task.state === 'open') || (task.state === 'draft')) {
                    $scope.tasksToClose.push(addTaskToTasksToClose(task));
                }
            });
        }

        function addTaskToTasksToClose(task) {
            var resources = openstcResourcesService.officers.items;
            var taskToClose = angular.copy(task);

            var res = _.find(resources, function(officer) {
                return officer.id == taskToClose.user_id[0];
            });

            if (res != undefined) {
                taskToClose.hex_color = res.hex_color;
                taskToClose.checked = true;
            } else {
                taskToClose.hex_color = '#f0ad4e';
                taskToClose.checked = true;
            }
            return taskToClose;
        }

        function filterTasksToClose(tasks){
            let tasksToClose = [];

            _.forEach(tasks, function (task) {
                if ((task.state === 'open') || (task.state === 'draft')) {
                    tasksToClose.push(addTaskToTasksToClose(task));
                }
            });

            if (tasksToClose.length > 0) {
                $scope.showCloseWeekTasksButton = true;
            } else {
                $scope.showCloseWeekTasksButton = false;
            }
            return tasksToClose;
        }

        function closeWeekTasks(){
            var tasksToAssign = [];
            _.forEach($scope.tasksToClose, function (task) {
                if (!task.user_id && !task.team_id){
                    tasksToAssign.push(task);
                }
            });

            var preValidate = function(data) {
                var tasksToAssign = [];
                var tasksToClose = [];
                if (data.action.id == "closeWeekTasksNotAssigned") {
                    angular.forEach(data.model, function(task) {
                        tasksToAssign.push([task.id, {
                            user_id: task.user_id ? task.user_id[0] : false,
                            team_id: task.team_id ? task.team_id[0] : false,
                            partner_id: task.partner_id ? task.partner_id[0] : false
                        }])
                    });
                }
                angular.forEach($scope.tasksToClose, function(task) {
                    tasksToClose.push({id: task.id, planned_hours: task.planned_hours});
                });
                swif.data
                    .callKw('task', 'close_tasks', [tasksToAssign, tasksToClose], {context: swif.user.getAuthenticatedUser().context})
                    .then(function () {
                        $rootScope.$emit('closeModalEvent');
                        displayPlanning();
                    });

            }

            if (_.isEmpty(tasksToAssign)){
                var action = swif.action.getActionById('task', 'planning', 'closeWeekTasks');
                if (action) {
                    swif.action.dispatch('task', action, $scope.tasksToClose, {preValidate});
                }
            } else {
                var action = swif.action.getActionById(
                    'task', 'planning', 'closeWeekTasksNotAssigned', tasksToAssign
                );
                if (action) {
                    swif.action.dispatch('task', action, tasksToAssign, {preValidate});
                }
            }
        }

        function watchPlannedTasksItems(tasks) {
            if (tasks) {
                $scope.eventSources[0] = _.map(tasks, getEventFromTask);
                _.remove($scope.eventSources[0], function (event) {
                    return _.isUndefined(event);
                });
                $scope.tasksToClose = filterTasksToClose(tasks);
            } else {
                $scope.eventSources[0] = [];
            }
            if ($scope.printView) {
                //load more data for the print
                var options = {
                    inter_ids: [],
                    request_ids: []
                };
                _.forEach(tasks, function (task) {
                    if (task.project_id) {
                        options.inter_ids.push(task.project_id[0]);
                    }
                    if (task.ask_id) {
                        options.request_ids.push(task.ask_id[0]);
                    }
                });
                loadPrintDataFromTask(options);
            }
        }

        function fullcalendarDrop (date, jsEvent, ui, resourceId) {
            date = swif.date.fixPlanningTZ(date);
            var cls = ui.helper.attr('class').split(' ');
            var taskId;
            cls.forEach(function (cl) {
                if (cl.startsWith('task-')) {
                    taskId = parseInt(cl.split('-')[1], 10);
                }
            });
            var droppedTask;
            var intervention;
            var promises = [];
            var current = openstcResourcesService.current;
            _.forEach($scope.tasks.items, function (task) {
                if (task.id === taskId) {
                    droppedTask = task;
                }
            });
            if (!droppedTask) {
                return;
            }
            //support intervention.state === 'duplicate'
            _.forEach($scope.interventions.items, function (inter) {
                if (inter.id === droppedTask.project_id[0]) {
                    intervention = inter;
                    if (inter.is_long_term) {
                        var copy = angular.copy(droppedTask);
                        openstc.task.removeFromPlanning(copy);
                        promises.push(swif.data.create('task', copy));
                    }
                }
            });
            droppedTask.date_start = swif.date.parseDatetime(date);
            if (!droppedTask.planned_hours) {
                droppedTask.planned_hours = 1;
            }
            droppedTask.date_end = swif.date.addHours(
                droppedTask.date_start, droppedTask.planned_hours
            );

            //assigned to ?
            if (current.officers.length === 1) {
                var currentOfficer = current.officers[0];
                droppedTask.user_id = [currentOfficer.id, currentOfficer.name];
                droppedTask.team_id = false;
                droppedTask.partner_id = false;
            } else if (current.team) {
                droppedTask.user_id = false;
                droppedTask.team_id = [current.team.id, current.team.name];
                droppedTask.partner_id = false;
            } else if (current.serviceSupplier) {
                droppedTask.user_id = false;
                droppedTask.team_id = false;
                droppedTask.partner_id = [current.serviceSupplier.id, current.serviceSupplier.name];
            }
            if (current.officers.length > 1) {
                var onDropped = function () {
                    return openstc.planning.assignTaskToMultipleOfficers(
                        droppedTask, current.officers, $scope
                    );
                };
                var onPlanned = function () {
                    swif.message.addInfo('Task has been planned successfully');
                    createOrUpdatePlannedTasks();
                    refreshPlanningTasks();
                };
                $q.all(promises).then(onDropped).then(onPlanned);
            } else  {
                //droppedTask.state = 'open';
                promises.push(openstc.planning.saveTask(droppedTask));
                $q.all(promises).then(function (data) {
                    swif.message.addInfo('Task has been planned successfully');
                    //TODO: try to add it by hand
                    var found = false;
                    _.forEach($scope.plannedTasks.items, function (task) {
                        if (task.id === droppedTask.id) {
                            found = true;
                            swif.data.updateObj(droppedTask, task);
                        }
                    });
                    if (!found) {
                        $scope.plannedTasks.items.push(droppedTask);
                    }
                    $scope.tasks.updateItem(droppedTask);
                    if (intervention) {
                        $scope.interventions.updateItem(intervention);
                        if (intervention.is_long_term) {
                            var copy = angular.copy(droppedTask);
                            delete copy.id;
                            copy.state = 'draft';
                            copy.id = data[0].result;
                            $scope.tasks.items.unshift(copy);
                            $scope.tasks.updateItem(copy);
                        }
                    }
                    //TODO: try to refresh only this task and it's project.
                    //refreshPlanningTasks();
                });
            }
        }

        function fullcalendarEventClick(event, jsEvent, view) {
            console.log(event, jsEvent);
            // If altKey is pressed on click, open the duplicate modal instead of the task modal
            if (jsEvent.altKey) {
                if ((event.data._type === 'task') && !(event.data.external)) {
                    var filter = {};
                    var task = getTaskFromEvent(event);
                    filter.fields = openstc.task.COLLECTION_FIELDS;
                    swif.data.get('task', task.id, filter).then(function (task) {
                        var action = swif.action.getActionById('task', 'primary', 'copy', task);
                        var options = {
                            preValidate: $scope.preValidateTask,
                            callback: $scope.callbackTask
                        };
                        swif.action.dispatch('task', action, task, options);
                    });
                }
            } else {
                // We don't want the edit modal for external events.
                if (event.data) {
                    //we don't want to open the modal if user click on the checkbox
                    if (!(jsEvent.target.tagName==="INPUT") && !(jsEvent.target.type==="checkbox")) {
                        if ((event.data._type === 'task') && ! (event.data.external)) {
                            var filter = {};
                            var task = getTaskFromEvent(event);
                            filter.fields = openstc.task.COLLECTION_FIELDS;
                            swif.data.get('task', task.id, filter)
                                .then(function (task) {
                                    var modalInstance = $uibModal.open({
                                        templateUrl: 'partials/openstc/planning_event_modal.html',
                                        controller: 'PlanningEventModal',
                                        resolve: {
                                            modalParams: function () {
                                                return {task: task};
                                            }
                                        }
                                    });
                                    modalInstance.result.then(function () {
                                        createOrUpdatePlannedTasks();
                                        refreshPlanningTasks();
                                    });
                                });
                        } else if (event.data._type === 'punch' ||
                            ((event.data._type === 'task') && event.data.external)) {
                            showEventPanel(event.data, jsEvent);
                        }
                    }
                }
            }
        }

        function fullcalendarToggleExpand() {
            $scope.expanded = !$scope.expanded;
        }

        function updateTaskFromEvent(event) {
            //update task from both collections : planning-tasks and planned-tasks
            var task = getTaskFromEvent(event);
            openstc.planning.updateTaskFromEvent(task, event);
            //task has been modified but the save is a promise;
            _.forEach($scope.tasks.items, function (leftTask) {
                if (leftTask.id === event.id) {
                    leftTask.date_start = task.date_start;
                    leftTask.date_end = task.date_end;
                    leftTask.planned_hours = task.planned_hours;
                }
            });
            return swif.data.save(
                'task',
                task.id,
                {
                    date_start: task.date_start,
                    date_end: task.date_end,
                    planned_hours: task.planned_hours
                }
            );
        }

        function fullcalendarEventDrop(event){
            updateTaskFromEvent(event).then(function () {
                    swif.message.addInfo('Task has been updated successfully');
                }
            );
        }

        function fullcalendarEventResize(event) {
            updateTaskFromEvent(event).then(function () {
                    swif.message.addInfo('Task has been updated successfully');
                }
            );
        }

        function onClickTaskToClose(e){
            if(e.currentTarget.checked){
                addToTasksToCloseById(e.currentTarget.id);
            }else{
                removeTaskToCloseById(e.currentTarget.id);
            }
        }

        function fullcalendarEventRender (event, element, view) {
            if(event.data) { // has the task attached to it && multi user agent
                element.find('.fc-time').remove();
            }
            if(event.data && event.data._type == 'task') {
                //if in multi user agent mode, add the status in the event
                var state = swif.state.getStateInfo(event.data.state, event.data);
                var title = swif.i18n.getString(state.title);
                //here we post process html task in planning
                //normal process is done by fullcalendar
                //event is created in service.js
                element.find('.fc-title').append('<br/>' + title);
                if(event.data.recurrence_id) {
                    element.find('.fc-title').prepend('<i class="fa fa-repeat fa-fw"></i>');
                }

                if ($scope.displayWeekTasksToClose && event.data.state!='done'){
                    var checkbox = document.createElement('input');
                    checkbox.type = "checkbox";
                    checkbox.checked = true;
                    checkbox.id = event.data.id;
                    checkbox.onclick = onClickTaskToClose;
                    checkbox.classList.add('pull-left');
                    checkbox.style.marginRight = "2px";
                    element.find('.fc-title').before(checkbox);
                    element[0].style.borderWidth = '3px';
                    element[0].style.borderColor = '#5cb85c';
                }
            }
            if(event.data && event.data._type == 'punch') {
                var icon = "fa-sign-"+ event.data.type;
                var classes = "fa "+icon+" punch-event "+event.data.type;
                var color = _.get(openstc.planning.userColor, event.data.user_id[0], '#888');
                element.append('<i class="' + classes + ' "style="color: ' + color + '"></i>');
                element.find('.fc-title').remove();
            }
        }

        function fullcalendarSelect (start, end) {
            start = swif.date.fixPlanningTZ(start);
            end = swif.date.fixPlanningTZ(end);
            var modalParams = getCurrentResource();
            modalParams.date_start = start;
            modalParams.date_end = end;
            modalParams.planning = $scope.currentPlanning;
            var inter = $scope.interventions.currentItem;
            if (inter) {
                modalParams.project_id = [inter.id, inter.name];
                modalParams.name = inter.name;
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/openstc/planning_add_modal.html',
                controller: 'PlanningEventModal',
                resolve: {
                    modalParams: function () {
                        return modalParams;
                    }
                }

            });
            modalInstance.result.then(function (task) {
                createOrUpdatePlannedTasks();
                refreshPlanningTasks();
                $scope.plannedTasks.getItems();
            });
        }

        /**
         * Manage interventions
         */
        function displayInterventionPanel (intervention) {
            if ($scope.display_inter_id !== intervention.id) {
                $scope.display_inter_id = intervention.id;
            } else {
                $scope.closeInterventionPanel(intervention);
            }
        }

        function closeInterventionPanel () {
            delete $scope.display_inter_id;
        }

        function getInterventions () {
            $scope.interventions.getItems();
        }

        function getTasks() {
            $scope.tasks.getItems();
        }

        function onInterventionSelected (item) {
            var filter = {};
            filter.fields = openstc.planning.TASKS_FIELDS;
            swif.data.addExtraFilter(filter, 'projects', 'project_id', 'in', [item.id]);
            swif.data.addFilter(filter, 'state', 'in', ['draft', 'open', 'pending', 'absent']);
            if ($scope.project_type === 'patrimoine_contract') {
                swif.data.addExtraFilter(filter, 'contract', '|');
                swif.data.addExtraFilter(filter, 'contract', '&');
                swif.data.addExtraFilter(filter, 'contract', 'site_ids', '=', false);
                swif.data.addExtraFilter(filter, 'contract', 'site1', '!=', false);
                swif.data.addExtraFilter(filter, 'contract', '&');
                swif.data.addExtraFilter(filter, 'contract', 'equipment_ids', '=', false);
                swif.data.addExtraFilter(filter, 'contract', 'equipment_id', '!=', false);
            }
            swif.data.sortOn(filter, 'state', 'ASC');
            $scope.tasks.currentFilter = filter;
            $scope.displayTasksSearch = item.tasks.length > 10;
            //$scope.getTasks(); //REMOVED BECAUSE MAKE THE TASK HTTP REQUEST TWICE
        }

        function watchCurrentIntervention (intervention) {
            if ($scope.tasks) {
                $scope.tasks.items = [];
            }
            if (intervention) {
                onInterventionSelected(intervention);
            }
        }

        function watchInterventionsItems(newV, oldV) {
            var request_ids = [];

            angular.forEach(newV, function(intervention) {
                if (intervention.ask_id) {
                    request_ids.push(intervention.ask_id[0]);
                }
            });
            if (!request_ids) {
                return;
            }

            var filter = {fields: ['claimer_priority']}
            swif.data.addFilter(filter, 'id', 'in', request_ids);
            swif.data.get('intervention_request', undefined, filter).then(requests => {
                var request_priority_ids = [];

                angular.forEach(requests, function(request) {
                    angular.forEach(newV, function(intervention) {
                        if (request.id === intervention.ask_id[0]) {
                            intervention.request_obj = request;

                            if (request.claimer_priority.length > 0) {
                                request_priority_ids.push(request.claimer_priority[0]);
                            }
                        }
                    });
                });

                if (request_priority_ids.length > 0) {
                    filter = {fields: ['color']};
                    swif.data.addFilter(filter, 'id', 'in', request_priority_ids);
                    swif.data.get('intervention_request_priority', undefined, filter).then(priorities => {

                        angular.forEach(priorities, function(priority) {
                            angular.forEach(newV, function(intervention) {

                                if (intervention.request_obj && priority.id === intervention.request_obj.claimer_priority[0]) {
                                    intervention.request_obj.claimer_priority_obj = priority;
                                }
                            });
                        });
                    });
                }
            });
        }

        /**
         * Manage tasks
         */
        function getTaskTooltip (task) {
            //task.date_start | swifFormatDatetime
            // + ' - ' + task.user_id[1] || task.team_id[1] || task.partner_id[1]
            var buff = [];
            if (task.date_start) {
                buff.push(swif.date.formatDatetime(task.date_start));
            }
            if (task.user_id) {
                buff.push(task.user_id[1]);
            }
            if (task.team_id) {
                buff.push(task.team_id[1]);
            }
            if (task.partner_id) {
                buff.push(task.partner_id[1]);
            }
            return buff.join(' - ');
        }

        function setPlanningDateAndResourceFromTask (task) {
            if (task.date_start) {
                uiCalendarConfig.calendars.planning.fullCalendar('gotoDate', task.date_start);
            }
            var found;
            if (task.user_id) {
                found = false;
                _.forEach(openstcResourcesService.officers.items, function (officer) {
                    if (officer.id === task.user_id[0]) {
                        openstcResourcesService.setCurrentOfficer(officer);
                        found = true;
                    }
                });
                if (!found && _.contains(_.keys(openstc.planning.userColor), task.user_id[0].toString())) {
                    openstcResourcesService.setCurrentOfficer(task.user_id[0]);
                }
            } else if (task.team_id) {
                _.forEach(openstcResourcesService.teams.items, function (team) {
                    if (team.id === task.team_id[0]) {
                        openstcResourcesService.setCurrentTeam(team);
                    }
                });
            } else if (task.partner_id) {
                _.forEach(openstcResourcesService.service_suppliers.items, function (supplier) {
                    if (supplier.id === task.partner_id[0]) {
                        openstcResourcesService.setCurrentServiceSupplier(supplier);
                    }
                });
            }
        }
        function displayTaskPanel(task) {
            if ($scope.display_task_id !== task.id) {
                $scope.display_task_id = task.id;
            } else {
                $scope.closeTaskInfo(task);
            }
        }
        function closeTaskInfo () {
            delete $scope.display_task_id;
        }
        function onDragTaskComplete(data){
            console.log('drag success, data:', data);
        }

        function onChangePlanningType(planning) {
            if (!planning || !planning.id) {
                var calendarDate = $("#fullcalendar").fullCalendar('getDate');
                $scope.fullcalendar.businessHours = $scope.defaultBusinessHours;
                $scope.currentPlanning = false;
                $timeout( function(){
                    $("#fullcalendar").fullCalendar('gotoDate',calendarDate);
                }, 100 );
                return;
            }

            var filter = {};
            swif.data.addFilter(filter, 'id', '=', planning.id);
            swif.data.get('planning', undefined, filter).then(function (data) {
                $scope.currentPlanning = data[0];
                loadPlanningType($scope.currentPlanning);
            })
        }

        function fillWeekWithTask(planning) {
            if (!planning || !planning.id) {
                return;
            }
            var task = {};
            task.fromPlanning = true;
            task.planning = planning;
            task.date_start = openstc.planning.currentStart;
            task.date_end = openstc.planning.currentEnd;
            task.planned_hours = swif.date.getHours(task.date_start, task.date_end);
            task.consumable_asks = [];

            var ressource = $scope.selectedOfficersOrTeam;
            if (ressource.officers.length === 0) {
                ressource = getCurrentResource();
            }
            task.user_id = [ressource.officers[0].id, ressource.officers[0].complete_name];

            var action = swif.action.getActionById(
                'task', 'list', 'add', task
            );
            if (action) {
                var callback = function (error, data) {
                    openstc.planning.callbackTask(error, data);
                    //fix state that has been set to draft by callback
                    if (_.size(ressource.officers) > 1) {
                        //support multi officers
                        //temporarly remove first officer, a task has already been created for him
                        var firstOfficer = ressource.officers.shift();
                        console.log(data.model)
                        openstc.planning.assignTaskToMultipleOfficers(
                            data.model, ressource.officers, $scope
                        ).then(function () {
                            createOrUpdatePlannedTasks();
                            refreshPlanningTasks();
                        });
                        ressource.officers.unshift(firstOfficer);
                    }
                    createOrUpdatePlannedTasks();
                    refreshPlanningTasks();
                };
                var options = {
                    preValidate: openstc.planning.preValidateTask,
                    callback: callback
                };
                swif.action.dispatch('task', action, task, options);
            }
        }


        $scope.$on('$destroy', function() {
            document.removeEventListener('keydown', _eventkeydownFunction);
            document.removeEventListener('keyup', _eventkeyupFunction);
        });
    }

    function TaskAssignModalController($rootScope, $scope, swifInterventionsService) {
        console.log('init TaskAssignModalController');
        var $ctrl = this;
        $ctrl.model = $scope.model;
        angular.forEach($ctrl.model, function(task) {
            task._filters = swifInterventionsService.task.getFilters(task);
        });

        var closeEvent = $rootScope.$on('closeModalEvent', function() {
            $scope.$parent.$parent.cancel();
        });

        $scope.$on('$destroy', closeEvent);
    }

    function PlanningEventModal ($scope, $uibModalInstance, swif, openstc, modalParams) {
        'ngInject';
        $scope.options = modalParams;
        $scope.planningUsable = false;
        function getActionFromPlanningAction(id) {
            return swif.action.getActionById('task', 'planning', id, modalParams.task);
        }

        $scope.displayRemoveFromPlanningAction = function () {
            if (modalParams.task) {
                return getActionFromPlanningAction('removefromplanning') !== undefined;
            }
            return false;
        };
        $scope.removeFromPlanning = function () {
            var action = getActionFromPlanningAction('removefromplanning');
            if (action) {
                var options = {
                    preValidate: openstc.planning.preValidateTask,
                    callback: openstc.planning.callbackTask
                };
                swif.action.dispatch('task', action, modalParams.task, options);
                $uibModalInstance.close(modalParams.task);
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.preModal = function (data) {
            openstc.task.preModal(data);
        };
        $scope.preValidate = function (data) {
            return openstc.planning.preValidateTask(data);
        };
        $scope.callback = function (error, data) {
            openstc.planning.callbackTask(error, data);
            if (_.size($scope.options.officers) > 1) {
                //support multi officers
                //temporarly remove first officer, a task has already been created for him
                var firstOfficer = $scope.options.officers.shift();
                openstc.planning.assignTaskToMultipleOfficers(
                    data, $scope.options.officers, $scope
                ).then(function () {
                    $uibModalInstance.close($scope.options);
                });
                $scope.options.officers.unshift(firstOfficer);
            } else {
                $uibModalInstance.close($scope.options);
            }
        };
        var getTask = function () {
            if ($scope.options.date_start && $scope.options.date_end) {
                //var ds = swif.date.parseDatetime($scope.options.date_start);
                //var de = swif.date.parseDatetime($scope.options.date_end);
                var ds = $scope.options.date_start;
                var de = $scope.options.date_end;
                $scope.task = {
                    actions: [],
                    date_start: ds,
                    date_end: de,
                    planned_hours: swif.date.getHours(ds, de),
                    _type: 'task'
                };
                if ($scope.options.name) {
                    $scope.task.name = $scope.options.name;
                }
                if ($scope.options.project_id) {
                    $scope.task.project_id = $scope.options.project_id;
                }
                var resource;
                if ($scope.options.currentOfficer) {
                    resource = $scope.options.currentOfficer;
                    $scope.task.user_id = [resource.id, resource.complete_name || resource.name];
                }
                if (!_.isEmpty($scope.options.officers)) {
                    resource = $scope.options.officers[0];
                    $scope.task.user_id = [resource.id, resource.complete_name || resource.name];
                    $scope.task.fromPlanning = true;
                }
                if ($scope.options.team) {
                    resource = $scope.options.team;
                    $scope.task.team_id = [resource.id, resource.name];
                }
                if ($scope.options.serviceSupplier) {
                    resource = $scope.options.serviceSupplier;
                    $scope.task.partner_id = [resource.id, resource.complete_name];
                }
                return $scope.task;
            }
        };
        getTask(); //compat

        var checkPlanningUsability = function () {
            if (!$scope.options.planning) {
                return;
            }
            if (!$scope.options.date_start && !$scope.options.date_end) {
                return;
            }

            moment.locale('fr');
            var range_start = $scope.options.date_start.local();
            var range_end = $scope.options.date_end.local();
            for (const ts of $scope.options.planning.time_slots) {
                var date_start = angular.copy(range_start); // Taking current week selected on calendar
                var date_end = angular.copy(range_start);

                date_start.weekday(ts.day_start).hour(ts.range_start).minute((ts.range_start % 1) * 60)
                date_end.weekday(ts.day_end).hour(ts.range_end).minute((ts.range_end % 1) * 60)
                // If strictly out of range
                if ((range_start >= date_start && range_start < date_end) || // Start between work hour
                    (range_end > date_start && range_end <= date_end) || // End between work hour
                    (range_start >= date_start && range_end <= date_end) || // Fully in work hour
                    (range_start <= date_start && range_end >= date_end)) { // Contained in work hour
                    $scope.planningUsable = true;
                    break;
                }
            }
        };
        checkPlanningUsability()

        $scope.addAbsence = function () {
            var action = swif.action.getActionById(
                'task', 'planning', 'addabsence', modalParams.task
            );
            if (action) {
                //var tasks = swif.collections.getCollection('planned-tasks');
                var task = angular.copy(getTask());
                task.state = 'absent';
                var callback = function (error, data) {
                    openstc.planning.callbackTask(error, data);
                    //fix state that has been set to draft by callback
                    data.model.state = 'absent';
                    if (_.size($scope.options.officers) > 1) {
                        //support multi officers
                        //temporarly remove first officer, a task has already been created for him
                        var firstOfficer = $scope.options.officers.shift();
                        openstc.planning.assignAbsenceToMultipleOfficers(
                            data.model, $scope.options.officers, $scope
                        ).then(function () {
                            $uibModalInstance.close(task);
                        });
                        $scope.options.officers.unshift(firstOfficer);
                    } else {
                        $uibModalInstance.close(task);
                    }
                };
                var options = {
                    preValidate: openstc.planning.preValidateTask,
                    callback: callback
                };
                swif.action.dispatch('task', action, task, options);
            }
        };

        $scope.fillWeekWithTask = function () {
            if (!$scope.options.planning || !$scope.planningUsable) {
                return;
            }
            var action = swif.action.getActionById(
                'task', 'list', 'add', modalParams.task
            );
            if (action) {
                //var tasks = swif.collections.getCollection('planned-tasks');
                var task = angular.copy(getTask());
                task.fromPlanning = true;
                task.fillInRange = true;
                task.consumable_asks = [];
                task.planning = $scope.options.planning;

                var callback = function (error, data) {
                    openstc.planning.callbackTask(error, data);
                    //fix state that has been set to draft by callback
                    if (_.size($scope.options.officers) > 1) {
                        //support multi officers
                        //temporarly remove first officer, a task has already been created for him
                        var firstOfficer = $scope.options.officers.shift();
                        openstc.planning.assignTaskToMultipleOfficers(
                            data.model, $scope.options.officers, $scope
                        ).then(function () {
                            $uibModalInstance.close(task);
                        });
                        $scope.options.officers.unshift(firstOfficer);
                    } else {
                        $uibModalInstance.close(task);
                    }
                };
                var options = {
                    preValidate: openstc.planning.preValidateTask,
                    callback: callback
                };
                swif.action.dispatch('task', action, task, options);
            }
        }
    }

})();
